import React, { useState } from "react";
import {
  Button,
  Modal,
  Row,
  Typography,
} from "../common/utils/antd-imports/AntdImports";
import FloatingInput from "../common/float-input/FloatInput";
import "../../main.css";
import "./NewCampaignModal.css";
import { useMediaQuery } from "react-responsive";
const NewCampaignModal = ({ newCampaignModal, setNewCampaignModal, title }) => {
  const { Text } = Typography;
  const [otherGoal, setOtherGoal] = useState(false);
  const handleOk = () => {
    setNewCampaignModal(false);
  };
  const star = <span style={{ color: "#d2042d" }}>*</span>;
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
  };
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const modalWidth = isMobile ? 356 : 473;
  const modalHeight = isMobile ? 533 : 649;

  const [activeButtonId, setActiveButtonId] = useState(null);
  const getButtonStyle = (id) => {
    switch (id) {
      case "brand-awareness":
        return {
          backgroundColor:
            activeButtonId === "brand-awareness" ? "#d2042d" : "",
          color: activeButtonId === "brand-awareness" ? "#fff" : "#000",
        };

      case "website-traffic":
        return {
          backgroundColor:
            activeButtonId === "website-traffic" ? "#d2042d" : "",
          color: activeButtonId === "website-traffic" ? "#fff" : "#000",
        };

      case "generate-leads":
        return {
          backgroundColor: activeButtonId === "generate-leads" ? "#d2042d" : "",
          color: activeButtonId === "generate-leads" ? "#fff" : "#000",
        };

      case "boost-sales":
        return {
          backgroundColor: activeButtonId === "boost-sales" ? "#d2042d" : "",
          color: activeButtonId === "boost-sales" ? "#fff" : "#000",
        };

      case "expand-market":
        return {
          backgroundColor: activeButtonId === "expand-market" ? "#d2042d" : "",
          color: activeButtonId === "expand-market" ? "#fff" : "#000",
        };

      case "build-brand":
        return {
          backgroundColor: activeButtonId === "build-brand" ? "#d2042d" : "",
          color: activeButtonId === "build-brand" ? "#fff" : "#000",
        };

      case "test-market":
        return {
          backgroundColor: activeButtonId === "test-market" ? "#d2042d" : "",
          color: activeButtonId === "test-market" ? "#fff" : "#000",
        };

      case "others":
        return {
          backgroundColor: activeButtonId === "others" ? "#d2042d" : "",
          color: activeButtonId === "others" ? "#fff" : "#000",
        };
    }
  };
  const handleClick = (id) => {
    setActiveButtonId(id);
    if (id === "others") setOtherGoal(!otherGoal);
  };
  if (newCampaignModal) {
    return (
      <Modal
        title={title}
        open={newCampaignModal}
        onCancel={handleOk}
        width={modalWidth}
        height={modalHeight}
        footer={null}
      >
        <FloatingInput
          className="billboard-input-feild"
          label={
            <>
              {`Campaign Name `}
              {star}
            </>
          }
          customStyles={floatingInputStyles}
        />
        <div className="modal-label">
          <Text>Select your campaign goals</Text>
        </div>
        <div className="buttons-group">
          <Row className="campaign-goals">
            <Button
              className="goal-btn"
              id="brand-awareness"
              style={getButtonStyle("brand-awareness")}
              onClick={() => handleClick("brand-awareness")}
            >
              Increase brand awareness
            </Button>

            <Button
              className="goal-btn"
              id="website-traffic"
              style={getButtonStyle("website-traffic")}
              onClick={() => handleClick("website-traffic")}
            >
              Drive website traffic
            </Button>

            <Button
              className="goal-btn"
              id="generate-leads"
              style={getButtonStyle("generate-leads")}
              onClick={() => handleClick("generate-leads")}
            >
              Generate Leads
            </Button>

            <Button
              className="goal-btn"
              id="boost-sales"
              style={getButtonStyle("boost-sales")}
              onClick={() => handleClick("boost-sales")}
            >
              Boost Sales or Conversions
            </Button>

            <Button
              className="goal-btn"
              id="expand-market"
              style={getButtonStyle("expand-market")}
              onClick={() => handleClick("expand-market")}
            >
              Expand Market Reach
            </Button>

            <Button
              className="goal-btn"
              id="build-brand"
              style={getButtonStyle("build-brand")}
              onClick={() => handleClick("build-brand")}
            >
              Build brand loyal quality
            </Button>

            <Button
              className="goal-btn"
              id="test-market"
              style={getButtonStyle("test-market")}
              onClick={() => handleClick("test-market")}
            >
              Test a New Market
            </Button>

            <Button
              className="goal-btn"
              id="others"
              style={getButtonStyle("others")}
              onClick={() => handleClick("others")}
            >
              Others
            </Button>
          </Row>
          {otherGoal && (
            <FloatingInput label="Please specify your Campaign Goal" />
          )}
          <Button
            className="button  modal-btn new-campaign"
            onClick={() => setNewCampaignModal(true)}
          >
            <Text className="search-text">Create New Campaign</Text>{" "}
          </Button>
        </div>
      </Modal>
    );
  }
};

export default NewCampaignModal;
